import type { ReactNode } from "react"

export function SectionHeading({ children }: { children: ReactNode }) {
  return (
    <div className="border-fr-border text-fr-ink mt-[22px] mb-[10px] border-t pt-[14px] text-[15px] font-bold uppercase">
      <span>{children}</span>
    </div>
  )
}
